import { ReduxStore } from "../../reducers/root_reducer";

const getFilter = (state: ReduxStore, props) => state.filter;

export default getFilter;
